import {
  getUrlParameterByName,
  getDayRangeTitle,
  downLoadCSVFunc,
} from "../../../utils/utility";
import { map, isEmpty, sortBy, sumBy } from "lodash";
import moment from "moment";

export default function createCsvFile() {
  const nav = getUrlParameterByName("nav") || "overview";
  const popUrl = getUrlParameterByName("pop_url");
  switch (nav) {
    case "overview": {
      overview.call(this);
      break;
    }
    case "pop": {
      if (popUrl) {
        popularPage.call(this, popUrl);
      }
      break;
    }
    case "demographics": {
      demographics.call(this);
      break;
    }
    case "additional-demographics": {
      addDemo.call(this);
      break;
    }
    case "device": {
      device.call(this);
      break;
    }
  }
}

function createFilename(d, type) {
  const { client_tags, websiteId } = this.props;
  const tag = client_tags ? client_tags.find(it => it.id === websiteId) : null;
  const domain = tag && tag.domain ? tag.domain : "Unknown";
  const dayRange = this.getDayRangeTitle(d).replace(/\s+/g, "");
  const time = moment().format("YYYYMMDD");
  return `${domain}_${dayRange}_${type}_${time}`;
}

function device() {
  this.setState({ onCsvReportDownload: true, showDownloadDialog: false });
  const {
    statsByDevice,
    statsByOsType,
    statsByDeviceModel,
    client_info,
    client_sites,
    websiteId,
    dayRange,
  } = this.props;
  let client_name = client_info.name;
  let websiteName = "";
  if (client_sites && client_sites.length > 0) {
    for (let i = 0; i < client_sites.length; i++) {
      if (Number(client_sites[i].value) === Number(websiteId)) {
        websiteName = client_sites[i].label;
        break;
      }
    }
  }
  const s = client_sites.find(function(site) {
    return site.value === websiteId;
  });
  let csvFileName = createFilename.call(
    this,
    dayRange,
    "Site Analytics Devices",
  );
  let title = "Report Details,\r\n";
  let title_line =
    (websiteName ? websiteName + " " : "") +
    "Site Analytics Devices Report,\r\n";
  let report_date_line = "Date," + moment().format("MM/DD/YYYY") + ",\r\n";
  let client_name_line = "Client Name," + client_name + ",\r\n";
  let date_filter_line =
    "Campaign Date Filter," + getDayRangeTitle(dayRange) + ",\r\n";
  // let pageName = `Page Name,${popUrl},,,,,,\r\n`;
  const breakLine = ",,,,,,,\r\n";
  function formatNumber(num, total) {
    return total > 0 ? Math.round((num / total) * 10000, 10) / 100 + "%" : "-";
  }
  function reduce(values) {
    return values.reduce((a, b) => {
      if (typeof a === "number") return a + b.value;
      else return a.value + b.value;
    });
  }
  function formatLine(data) {
    if (data && data.length > 0) {
      let line_str = "";
      const total = reduce(data);
      data.forEach(it => {
        line_str += `${it.key},${formatNumber(it.value, total)},\r\n`;
      });
      return line_str;
    } else {
      return "";
    }
  }
  function sort(data) {
    if (data && data.length > 0) {
      data.sort((a, b) => b.value - a.value);
    }
    return data;
  }
  let device_line = "Device Insights,\r\n";
  device_line += "Device Type,\r\n";
  device_line += formatLine(sort(statsByDevice && statsByDevice.values));
  let type_line = "Operating System,\r\n";
  type_line += formatLine(sort(statsByOsType && statsByOsType.values));
  let model_line = "Device Model,\r\n";
  model_line += formatLine(
    sort(statsByDeviceModel && statsByDeviceModel.values),
  );

  const data =
    title +
    title_line +
    report_date_line +
    client_name_line +
    date_filter_line +
    breakLine +
    device_line +
    breakLine +
    type_line +
    breakLine +
    model_line;
  downLoadCSVFunc(data, csvFileName.replace(new RegExp(" ", "g"), "_"));
  setTimeout(
    function() {
      this.setState({ onCsvReportDownload: false });
    }.bind(this),
    2000,
  );
}

function addDemo() {
  this.setState({ onCsvReportDownload: true, showDownloadDialog: false });
  const {
    statsTopAttributes,
    client_info,
    client_sites,
    websiteId,
    dayRange,
  } = this.props;
  let client_name = client_info.name;
  let websiteName = "";
  if (client_sites && client_sites.length > 0) {
    for (let i = 0; i < client_sites.length; i++) {
      if (Number(client_sites[i].value) === Number(websiteId)) {
        websiteName = client_sites[i].label;
        break;
      }
    }
  }
  const s = client_sites.find(function(site) {
    return site.value === websiteId;
  });
  let csvFileName = createFilename.call(
    this,
    dayRange,
    "Site Analytics Demographic and Behavior",
  );
  let title = "Report Details,\r\n";
  let title_line =
    (websiteName ? websiteName + " " : "") +
    "Site Analytics Demographics and Behaviors Report,\r\n";
  let report_date_line = "Date," + moment().format("MM/DD/YYYY") + ",\r\n";
  let client_name_line = "Client Name," + client_name + ",\r\n";
  let date_filter_line =
    "Campaign Date Filter," + getDayRangeTitle(dayRange) + ",\r\n";
  // let pageName = `Page Name,${popUrl},,,,,,\r\n`;
  const breakLine = ",,,,,,,\r\n";
  const { behavioral, demographic } = statsTopAttributes;
  function formatNumber(num) {
    return (num * 100).toFixed(2) + "%";
  }
  function formatLine(data) {
    if (data && data.length > 0) {
      let line_str = "";
      data.forEach(it => {
        line_str += `${it.name},${it.label},${formatNumber(
          it.visitorPercentage,
        )},\r\n`;
      });
      return line_str;
    } else {
      return "";
    }
  }
  function sort(data) {
    if (data && data.length > 0) {
      data.sort((a, b) => b.visitors - a.visitors);
    }
    return data;
  }
  let line1 = "Popular Demographic/Household Attributes,\r\n";
  line1 += "Attribute,Value Pair,Unique Visits,\r\n";
  line1 += formatLine(sort(demographic));
  let line2 = "Popular Behavioral Attributes,\r\n";
  line2 += "Attribute,Value Pair,Unique Visits\r\n";
  line2 += formatLine(sort(behavioral));
  const data =
    title +
    title_line +
    report_date_line +
    client_name_line +
    date_filter_line +
    breakLine +
    line1 +
    breakLine +
    line2;
  downLoadCSVFunc(data, csvFileName.replace(new RegExp(" ", "g"), "_"));
  setTimeout(
    function() {
      this.setState({ onCsvReportDownload: false });
    }.bind(this),
    2000,
  );
}

function demographics() {
  this.setState({ onCsvReportDownload: true, showDownloadDialog: false });
  const {
    client_info,
    client_sites,
    websiteId,
    dayRange,
  } = this.props;
  let client_name = client_info.name;
  let websiteName = "";
  if (client_sites && client_sites.length > 0) {
    for (let i = 0; i < client_sites.length; i++) {
      if (Number(client_sites[i].value) === Number(websiteId)) {
        websiteName = client_sites[i].label;
        break;
      }
    }
  }
  const s = client_sites.find(function(site) {
    return site.value === websiteId;
  });
  let csvFileName = createFilename.call(
    this,
    dayRange,
    "Site Analytics Demographics",
  );
  let title = "Report Details,\r\n";
  let title_line =
    (websiteName ? websiteName + " " : "") + "Site Anayltics Report,\r\n";
  let report_date_line = "Date," + moment().format("MM/DD/YYYY") + ",\r\n";
  let client_name_line = "Client Name," + client_name + ",\r\n";
  let date_filter_line =
    "Campaign Date Filter," + getDayRangeTitle(dayRange) + ",\r\n";
  // let pageName = `Page Name,${popUrl},,,,,,\r\n`;
  const breakLine = ",,,,,,,\r\n";

  function formatNumber(num, total) {
    return Math.round((num / total) * 10000, 10) / 100 + "%";
  }
  function reduce(values) {
    return values.reduce((a, b) => {
      if (typeof a === "number") return a + b.value;
      else return a.value + b.value;
    });
  }
  function formatLine(data) {
    if (data && data.values.length > 0) {
      let line_str = "";
      const total = reduce(data.values);
      data.values.forEach(it => {
        line_str += `${it.key},${formatNumber(it.value, total)},\r\n`;
      });
      return line_str;
    } else {
      return "";
    }
  }
  function sort(data) {
    if (data && data.values.length > 0) {
      data.values.sort((a, b) => b.value - a.value);
    }
    return data;
  }

  const data =
    title +
    title_line +
    report_date_line +
    client_name_line +
    date_filter_line +
  downLoadCSVFunc(data, csvFileName.replace(new RegExp(" ", "g"), "_"));
  setTimeout(
    function() {
      this.setState({ onCsvReportDownload: false });
    }.bind(this),
    2000,
  );
}

function overview() {
  this.setState({ onCsvReportDownload: true, showDownloadDialog: false });
  const {
    clients,
    client_info,
    websiteId,
    dayRange,
    client_sites,
    domesticVisitsSummary,
    statsByTimeOfDay,
    states,
    kindOfReport,
  } = this.props;
  let client_name = client_info.name;
  let websiteName = "";
  if (client_sites && client_sites.length > 0) {
    for (let i = 0; i < client_sites.length; i++) {
      if (Number(client_sites[i].value) === Number(websiteId)) {
        websiteName = client_sites[i].label;
        break;
      }
    }
  }
  const s = client_sites.find(function(site) {
    return site.value === websiteId;
  });
  let csvFileName = createFilename.call(
    this,
    dayRange,
    kindOfReport === "map"
      ? "Consumer Geographic Traffic"
      : "Site Analytics Overview",
  );
  let title = "Report Details,\r\n";
  let title_line =
    (websiteName ? websiteName + " " : "") + "Site Anayltics Report,\r\n";
  let report_date_line = "Date," + moment().format("MM/DD/YYYY") + ",\r\n";
  let client_name_line = "Client Name," + client_name + ",\r\n";
  let date_filter_line =
    "Campaign Date Filter," + getDayRangeTitle(dayRange) + ",\r\n";
  // let pageName = `Page Name,${popUrl},,,,,,\r\n`;
  const breakLine = ",,,,,,,\r\n";
  let overview_line =
    "Total Visits," +
    parseInt(domesticVisitsSummary.totalVisits) +
    ",,,,,,\r\n";
  overview_line +=
    "Unique Visits," +
    parseInt(domesticVisitsSummary.uniqueVisits) +
    ",,,,,,\r\n";
  // let channel_reach_line = "Media Reach,,,,,,,\r\n";
  // channel_reach_line += "Direct Mail," + reachByChannels[0].value + ",,,,,,\r\n";
  // channel_reach_line += "Email," + reachByChannels[1].value + ",,,,,,\r\n";
  // channel_reach_line += "Social," + reachByChannels[2].value + ",,,,,,\r\n";
  // channel_reach_line += "Display," + reachByChannels[3].value + ",,,,,,\r\n";
  let visits_by_time_line = "Visits by Time of Day,,,,,,,\r\n";
  if (statsByTimeOfDay && statsByTimeOfDay.stats) {
    const timeTotal = sumBy(statsByTimeOfDay.stats, val => {
      return val.unique;
    });
    map(statsByTimeOfDay.stats, stat => {
      visits_by_time_line +=
        stat.type +
        "," +
        (stat.unique / timeTotal).toLocaleString(undefined, {
          style: "percent",
          minimumFractionDigits: 2,
        }) +
        ",,,,,,\r\n";
    });
  }
  let geographic_traffic_line = "Geographic Traffic,,,,,,,\r\n";
  if (states) {
    const total = sumBy(states, val => {
      return val.unique;
    });
    const _states = sortBy(states, state => -state.unique);
    map(_states, state => {
      geographic_traffic_line +=
        state.type +
        "," +
        (state.unique / total).toLocaleString(undefined, {
          style: "percent",
          minimumFractionDigits: 2,
        }) +
        ",,,,,,\r\n";
    });
  }

  const data =
    title +
    title_line +
    report_date_line +
    client_name_line +
    date_filter_line +
    breakLine +
    overview_line +
    breakLine +
    visits_by_time_line +
    breakLine +
    geographic_traffic_line;
  downLoadCSVFunc(data, csvFileName.replace(new RegExp(" ", "g"), "_"));
  setTimeout(
    function() {
      this.setState({ onCsvReportDownload: false });
    }.bind(this),
    2000,
  );
}

function popularPage(popUrl) {
  this.setState({ onCsvReportDownload: true, showDownloadDialog: false });
  const {
    clients,
    client_info,
    websiteId,
    dayRange,
    client_sites,
    domesticVisitsSummary,
    // reachByChannels,
    statsByTimeOfDay,
    states,
    // statsByTime
  } = this.props;
  let client_name = client_info.name;
  let websiteName = "";
  if (client_sites && client_sites.length > 0) {
    for (let i = 0; i < client_sites.length; i++) {
      if (Number(client_sites[i].value) === Number(websiteId)) {
        websiteName = client_sites[i].label;
        break;
      }
    }
  }
  const s = client_sites.find(function(site) {
    return site.value === websiteId;
  });
  let csvFileName = createFilename.call(
    this,
    dayRange,
    "Site Analytics_Most Popular Pages",
  );
  let title = "Report Details,\r\n";
  let title_line =
    (websiteName ? websiteName + " " : "") +
    "Site Anayltics Popular Pages Report,\r\n";
  let report_date_line = "Date," + moment().format("MM/DD/YYYY") + ",\r\n";
  let client_name_line = "Client Name," + client_name + ",\r\n";
  let date_filter_line =
    "Campaign Date Filter," + getDayRangeTitle(dayRange) + ",\r\n";
  let pageName = `Page Name,${popUrl},,,,,,\r\n`;
  const breakLine = ",,,,,,,\r\n";
  let overview_line =
    "Total Visits," +
    parseInt(domesticVisitsSummary.totalVisits) +
    ",,,,,,\r\n";
  overview_line +=
    "Unique Visits," +
    parseInt(domesticVisitsSummary.uniqueVisits) +
    ",,,,,,\r\n";
  // let channel_reach_line = "Media Reach,,,,,,,\r\n";
  // channel_reach_line += "Direct Mail," + reachByChannels[0].value + ",,,,,,\r\n";
  // channel_reach_line += "Email," + reachByChannels[1].value + ",,,,,,\r\n";
  // channel_reach_line += "Social," + reachByChannels[2].value + ",,,,,,\r\n";
  // channel_reach_line += "Display," + reachByChannels[3].value + ",,,,,,\r\n";
  let visits_by_time_line = "Visits by Time of Day,,,,,,,\r\n";
  if (statsByTimeOfDay && statsByTimeOfDay.stats) {
    const timeTotal = sumBy(statsByTimeOfDay.stats, val => {
      return val.unique;
    });
    map(statsByTimeOfDay.stats, stat => {
      visits_by_time_line +=
        stat.type +
        "," +
        (stat.unique / timeTotal).toLocaleString(undefined, {
          style: "percent",
          minimumFractionDigits: 2,
        }) +
        ",,,,,,\r\n";
    });
  }
  let geographic_traffic_line = "Geographic Traffic,,,,,,,\r\n";
  if (states) {
    const total = sumBy(states, val => {
      return val.unique;
    });
    const _states = sortBy(states, state => -state.unique);
    map(_states, state => {
      geographic_traffic_line +=
        state.type +
        "," +
        (state.unique / total).toLocaleString(undefined, {
          style: "percent",
          minimumFractionDigits: 2,
        }) +
        ",,,,,,\r\n";
    });
  }

  const data =
    title +
    title_line +
    report_date_line +
    client_name_line +
    date_filter_line +
    pageName +
    breakLine +
    overview_line +
    breakLine +
    visits_by_time_line +
    breakLine +
    geographic_traffic_line;
  downLoadCSVFunc(data, csvFileName.replace(new RegExp(" ", "g"), "_"));
  setTimeout(
    function() {
      this.setState({ onCsvReportDownload: false });
    }.bind(this),
    2000,
  );
}



// WEBPACK FOOTER //
// ./src/components/Insights/website/createCSV.js